module.exports = __webpack_public_path__ + "static/media/chat_yellow.569a2402.svg";